// Thai translations
export const th: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'กำลังโหลด...',
  'common.error': 'เกิดข้อผิดพลาด',
  'common.retry': 'ลองอีกครั้ง',
  'common.cancel': 'ยกเลิก',
  'common.save': 'บันทึก',
  'common.continue': 'ดำเนินการต่อ',
  'common.back': 'กลับ',
  'common.next': 'ถัดไป',
  'common.skip': 'ข้าม',
  'common.done': 'เสร็จสิ้น',
  'common.yes': 'ใช่',
  'common.no': 'ไม่',
  'common.ok': 'ตกลง',
  'common.check': 'ตรวจสอบ',
  'common.correct': 'ถูกต้อง!',
  'common.incorrect': 'ไม่ถูกต้อง',
  'common.tryAgain': 'ลองอีกครั้ง',
  'common.start': 'เริ่มต้น',
  'common.finish': 'เสร็จสิ้น',
  'common.submit': 'ส่ง',

  // ==================== NAVIGATION ====================
  'nav.home': 'หน้าหลัก',
  'nav.courses': 'คอร์สเรียน',
  'nav.vocabulary': 'คำศัพท์',
  'nav.profile': 'โปรไฟล์',
  'nav.settings': 'ตั้งค่า',
  'nav.logout': 'ออกจากระบบ',
  'nav.leaderboard': 'กระดานผู้นำ',
  'nav.aiTutor': 'ติวเตอร์ AI',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'ยินดีต้อนรับสู่ KoreanFlow!',
  'onboarding.selectLanguage': 'เลือกภาษาของคุณ',
  'onboarding.selectLanguageDesc': 'เลือกภาษาสำหรับอินเทอร์เฟซแอป',
  'onboarding.selectGoal': 'เป้าหมายการเรียนของคุณคืออะไร?',
  'onboarding.selectGoalDesc': 'เราจะปรับแต่งเส้นทางการเรียนรู้ของคุณ',
  'onboarding.takeTest': 'ทำแบบทดสอบระดับ',
  'onboarding.takeTestDesc': 'ค้นหาระดับภาษาเกาหลีของคุณใน 5 นาที',
  'onboarding.skipTest': 'ข้ามไปก่อน',
  'onboarding.skipTestDesc': 'เริ่มจากระดับเริ่มต้น',
  'onboarding.letsGo': 'ไปกันเลย!',
  'onboarding.step': 'ขั้นตอน',
  'onboarding.of': 'จาก',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'แบบทดสอบระดับ',
  'levelTest.subtitle': 'มาค้นหาระดับภาษาเกาหลีของคุณกัน',
  'levelTest.duration': 'ประมาณ 5 นาที',
  'levelTest.questions': 'คำถาม',
  'levelTest.vocabulary': 'คำศัพท์',
  'levelTest.grammar': 'ไวยากรณ์',
  'levelTest.listening': 'การฟัง',
  'levelTest.speaking': 'การพูด',
  'levelTest.analyzing': 'กำลังวิเคราะห์ผลลัพธ์...',
  'levelTest.yourLevel': 'ระดับของคุณ',
  'levelTest.congratulations': 'ยินดีด้วย!',
  'levelTest.resultDesc': 'จากผลการทดสอบของคุณ',
  'levelTest.startLearning': 'เริ่มเรียน',
  'levelTest.retakeTest': 'ทำแบบทดสอบอีกครั้ง',
  'levelTest.sectionComplete': 'จบส่วนนี้แล้ว',
  'levelTest.nextSection': 'ส่วนถัดไป',
  'levelTest.listenAndAnswer': 'ฟังและตอบ',
  'levelTest.speakNow': 'พูดตอนนี้',
  'levelTest.tapToListen': 'แตะเพื่อฟัง',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'เริ่มต้น',
  'cefr.A2': 'พื้นฐาน',
  'cefr.B1': 'กลาง',
  'cefr.B2': 'กลางขั้นสูง',
  'cefr.C1': 'ขั้นสูง',
  'cefr.C2': 'เชี่ยวชาญ',
  'cefr.A1.desc': 'การทักทายพื้นฐานและการแสดงออกง่ายๆ',
  'cefr.A2.desc': 'การสนทนาง่ายๆ เกี่ยวกับชีวิตประจำวัน',
  'cefr.B1.desc': 'สามารถจัดการสถานการณ์การเดินทางส่วนใหญ่ได้',
  'cefr.B2.desc': 'สามารถโต้ตอบกับเจ้าของภาษาได้อย่างคล่องแคล่ว',
  'cefr.C1.desc': 'สามารถแสดงความคิดได้อย่างคล่องแคล่วและเป็นธรรมชาติ',
  'cefr.C2.desc': 'ความสามารถใกล้เคียงเจ้าของภาษาในทุกสถานการณ์',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'ลีก',
  'league.weeklyRanking': 'อันดับประจำสัปดาห์',
  'league.bronze': 'บรอนซ์',
  'league.silver': 'ซิลเวอร์',
  'league.gold': 'โกลด์',
  'league.platinum': 'แพลทินัม',
  'league.diamond': 'ไดมอนด์',
  'league.promotion': 'โซนเลื่อนขั้น',
  'league.demotion': 'โซนตกชั้น',
  'league.safe': 'โซนปลอดภัย',
  'league.weeklyXP': 'XP ประจำสัปดาห์',
  'league.rank': 'อันดับ',
  'league.daysLeft': 'วันที่เหลือ',
  'league.promoted': 'เลื่อนขั้นแล้ว!',
  'league.demoted': 'ตกชั้น',
  'league.stayed': 'คงอยู่',
  'league.noData': 'ยังไม่มีข้อมูลอันดับ',
  'league.earnXP': 'รับ XP เพื่อเข้าร่วมลีก!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'แอปเรียนภาษาเกาหลีอันดับ 1',
  'landing.title': 'เรียนภาษาเกาหลี',
  'landing.titleAccent': 'อย่างสนุกสนาน',
  'landing.subtitle': 'เชี่ยวชาญภาษาเกาหลีด้วยบทเรียนสั้นๆ เนื้อหา K-Pop และ K-Drama และการตอบกลับการออกเสียงด้วย AI เข้าร่วมกับผู้เรียนกว่า 1 ล้านคน!',
  'landing.getStarted': 'เริ่มต้นฟรี',
  'landing.learnMore': 'เรียนรู้เพิ่มเติม',
  'landing.login': 'เข้าสู่ระบบ',
  'landing.startFree': 'เริ่มต้นฟรี',
  'landing.learners': 'ผู้เรียน',
  'landing.lessons': 'บทเรียน',
  'landing.countries': 'ประเทศ',

  // ==================== FEATURES ====================
  'features.title': 'ทำไมต้อง KoreanFlow?',
  'features.subtitle': 'วิธีการเฉพาะตัวของเราผสมผสานเกมมิฟิเคชัน เนื้อหาจริง และเทคโนโลยี AI เพื่อทำให้การเรียนภาษาเกาหลีสนุกและมีประสิทธิภาพ',
  'features.streaks.title': 'สตรีคประจำวัน',
  'features.streaks.desc': 'สร้างนิสัยด้วยเป้าหมายรายวันและรางวัลสตรีค รักษาแรงจูงใจด้วย XP และอัญมณี',
  'features.folksong.title': 'เพลงพื้นบ้าน',
  'features.folksong.desc': 'เรียนภาษาเกาหลีผ่านเพลงพื้นบ้านดั้งเดิม เข้าใจเนื้อเพลงและวัฒนธรรม!',
  'features.culture.title': 'วัฒนธรรมเกาหลี',
  'features.culture.desc': 'สำรวจสุภาษิต สแลง และวลีที่จำเป็น เชี่ยวชาญการแสดงออกแบบแท้จริง',
  'features.ai.title': 'แชทบอท AI',
  'features.ai.desc': 'ฝึกสนทนากับติวเตอร์ AI รับการตอบกลับและการแก้ไขทันที',
  'features.leaderboard.title': 'กระดานผู้นำ',
  'features.leaderboard.desc': 'แข่งขันกับเพื่อนและผู้เรียนทั่วโลก ไต่อันดับประจำสัปดาห์!',
  'features.srs.title': 'คำศัพท์ SRS',
  'features.srs.desc': 'ระบบทบทวนอัจฉริยะทำให้คุณจำสิ่งที่เรียนได้ ตลอดไป',
  'features.pronunciation.title': 'การตอบกลับการออกเสียง',
  'features.pronunciation.desc': 'การวิเคราะห์การออกเสียงด้วย AI พร้อมคะแนนโดยละเอียด',

  // ==================== CTA ====================
  'cta.title': 'พร้อมเริ่มต้นการเดินทางของคุณหรือยัง?',
  'cta.subtitle': 'เข้าร่วมกับผู้เรียนหลายล้านคนและเริ่มพูดภาษาเกาหลีวันนี้ ฟรี!',
  'cta.button': 'เริ่มเรียนฟรี',

  // ==================== AUTH ====================
  'auth.login': 'เข้าสู่ระบบ',
  'auth.register': 'สมัครสมาชิก',
  'auth.email': 'อีเมล',
  'auth.emailPlaceholder': 'กรอกอีเมลของคุณ',
  'auth.password': 'รหัสผ่าน',
  'auth.passwordPlaceholder': 'สร้างรหัสผ่าน',
  'auth.confirmPassword': 'ยืนยันรหัสผ่าน',
  'auth.forgotPassword': 'ลืมรหัสผ่าน?',
  'auth.noAccount': 'ยังไม่มีบัญชี?',
  'auth.haveAccount': 'มีบัญชีอยู่แล้ว?',
  'auth.orContinueWith': 'หรือดำเนินการต่อด้วย',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'สร้างบัญชี',
  'auth.createAccountTitle': 'สร้างบัญชีของคุณ',
  'auth.createAccountSubtitle': 'เริ่มต้นการเดินทางเรียนภาษาเกาหลีวันนี้',
  'auth.username': 'ชื่อผู้ใช้',
  'auth.usernamePlaceholder': 'เลือกชื่อผู้ใช้',
  'auth.usernameHint': 'ตัวอักษร ตัวเลข และขีดล่างเท่านั้น',
  'auth.passwordHint': 'อย่างน้อย 8 ตัวอักษร พร้อมตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และตัวเลข',
  'auth.nativeLanguage': 'ภาษาแม่',
  'auth.nativeLanguageHint': 'เราจะแสดงคำอธิบายในภาษานี้',
  'auth.termsAgree': 'การสมัครสมาชิกหมายความว่าคุณยอมรับ',
  'auth.terms': 'เงื่อนไขการใช้งาน',
  'auth.and': 'และ',
  'auth.privacyPolicy': 'นโยบายความเป็นส่วนตัว',
  'auth.loginTitle': 'ยินดีต้อนรับกลับ',
  'auth.loginSubtitle': 'เข้าสู่ระบบเพื่อเรียนต่อ',
  'auth.loginButton': 'เข้าสู่ระบบ',
  'auth.registerButton': 'สมัครสมาชิก',
  'auth.rememberMe': 'จดจำฉัน',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'ยินดีต้อนรับกลับ',
  'dashboard.todayGoal': 'เป้าหมายวันนี้',
  'dashboard.streak': 'สตรีค',
  'dashboard.days': 'วัน',
  'dashboard.xp': 'XP',
  'dashboard.level': 'ระดับ',
  'dashboard.continueLearning': 'เรียนต่อ',
  'dashboard.recommended': 'แนะนำสำหรับคุณ',
  'dashboard.myCourses': 'คอร์สของฉัน',
  'dashboard.seeAll': 'ดูทั้งหมด',
  'dashboard.dailyGoalComplete': 'เป้าหมายรายวันสำเร็จ!',
  'dashboard.keepGoing': 'ทำต่อไป!',
  'dashboard.yourLevel': 'ระดับของคุณ',
  'dashboard.weeklyProgress': 'ความก้าวหน้าประจำสัปดาห์',

  // ==================== COURSES ====================
  'courses.title': 'คอร์สทั้งหมด',
  'courses.search': 'ค้นหาคอร์ส...',
  'courses.all': 'ทั้งหมด',
  'courses.beginner': 'เริ่มต้น',
  'courses.elementary': 'พื้นฐาน',
  'courses.intermediate': 'กลาง',
  'courses.advanced': 'ขั้นสูง',
  'courses.lessons': 'บทเรียน',
  'courses.enrolled': 'ลงทะเบียนแล้ว',
  'courses.progress': 'ความก้าวหน้า',
  'courses.completed': 'เสร็จสิ้น',
  'courses.recommended': 'แนะนำ',
  'courses.forYourLevel': 'สำหรับระดับของคุณ',
  'courses.locked': 'ล็อค',
  'courses.unlockWith': 'ปลดล็อคด้วย Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'กำลังโหลดบทเรียน...',
  'lesson.notFound': 'ไม่พบบทเรียน',
  'lesson.quit': 'คุณแน่ใจหรือไม่ที่จะออก? ความก้าวหน้าจะหายไป',
  'lesson.complete': 'บทเรียนเสร็จสมบูรณ์!',
  'lesson.perfect': 'สมบูรณ์แบบ!',
  'lesson.amazing': 'เยี่ยมมาก! คุณตอบถูกทุกข้อ!',
  'lesson.xpEarned': 'XP ที่ได้รับ',
  'lesson.accuracy': 'ความแม่นยำ',
  'lesson.correct': 'ถูกต้อง',
  'lesson.goBack': 'กลับ',
  'lesson.skip': 'ข้าม',
  'lesson.unknownType': 'ประเภทแบบฝึกหัดไม่รู้จัก',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'แตะเพื่อดูคำตอบ',
  'exercise.matchPairs': 'จับคู่',
  'exercise.matched': 'จับคู่แล้ว',
  'exercise.arrangeWords': 'จัดเรียงคำ',
  'exercise.speak': 'พูด',
  'exercise.listening': 'กำลังฟัง... พูดตอนนี้!',
  'exercise.processing': 'กำลังประมวลผลเสียงของคุณ...',
  'exercise.tapToSpeak': 'แตะเพื่อพูด',
  'exercise.cantSpeak': 'พูดไม่ได้ตอนนี้? ข้าม',
  'exercise.again': 'อีกครั้ง',
  'exercise.gotIt': 'เข้าใจแล้ว!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'ฝึกการออกเสียง',
  'pronunciation.subtitle': 'พัฒนาการออกเสียงภาษาเกาหลีด้วยการตอบกลับ AI',
  'pronunciation.selectLevel': 'เลือกระดับของคุณ',
  'pronunciation.beginner': 'เริ่มต้น',
  'pronunciation.intermediate': 'กลาง',
  'pronunciation.advanced': 'ขั้นสูง',
  'pronunciation.score': 'คะแนนของคุณ',
  'pronunciation.accuracy': 'ความแม่นยำ',
  'pronunciation.fluency': 'ความคล่องแคล่ว',
  'pronunciation.intonation': 'ทำนองเสียง',
  'pronunciation.feedback': 'การตอบกลับ',
  'pronunciation.tryAgain': 'ลองอีกครั้ง',
  'pronunciation.next': 'ถัดไป',
  'pronunciation.listen': 'ฟัง',
  'pronunciation.slow': 'ช้า',
  'pronunciation.sessionComplete': 'จบเซสชันแล้ว!',
  'pronunciation.bestScore': 'คะแนนดีที่สุด',
  'pronunciation.average': 'เฉลี่ย',
  'pronunciation.attempts': 'จำนวนครั้งที่ลอง',
  'pronunciation.practiceAgain': 'ฝึกอีกครั้ง',
  'pronunciation.changeLevel': 'เปลี่ยนระดับ',
  'pronunciation.tips': 'เคล็ดลับสำหรับการออกเสียงที่ดีขึ้น',
  'pronunciation.tip1': 'ฟังเสียงก่อน',
  'pronunciation.tip2': 'พูดชัดเจนและสม่ำเสมอ',
  'pronunciation.tip3': 'ใช้การเล่นช้าสำหรับคำที่ยาก',
  'pronunciation.tip4': 'ฝึกในสภาพแวดล้อมที่เงียบ',

  // ==================== VOCABULARY ====================
  'vocab.title': 'คำศัพท์',
  'vocab.totalWords': 'คำทั้งหมด',
  'vocab.mastered': 'เชี่ยวชาญแล้ว',
  'vocab.dueToday': 'วันนี้',
  'vocab.reviewSession': 'เซสชันทบทวน',
  'vocab.wordsDue': 'คำที่ต้องทบทวน',
  'vocab.startReview': 'เริ่มทบทวน',
  'vocab.allCaughtUp': 'ทบทวนหมดแล้ว!',
  'vocab.noWordsDue': 'ไม่มีคำที่ต้องทบทวน',
  'vocab.sessionComplete': 'เซสชันเสร็จสมบูรณ์!',
  'vocab.allWords': 'คำทั้งหมด',

  // ==================== PROFILE ====================
  'profile.title': 'โปรไฟล์',
  'profile.level': 'ระดับ',
  'profile.xpToNext': 'XP ถึงระดับถัดไป',
  'profile.totalXp': 'XP ทั้งหมด',
  'profile.currentStreak': 'สตรีคปัจจุบัน',
  'profile.lessonsDone': 'บทเรียนที่ทำเสร็จ',
  'profile.timeLearned': 'เวลาที่เรียน',
  'profile.achievements': 'ความสำเร็จ',
  'profile.settings': 'การตั้งค่า',
  'profile.dailyGoals': 'เป้าหมายรายวัน',
  'profile.allAchievements': 'ความสำเร็จทั้งหมด',
  'profile.logOut': 'ออกจากระบบ',
  'profile.koreanLevel': 'ระดับภาษาเกาหลี',

  // ==================== SETTINGS ====================
  'settings.title': 'การตั้งค่า',
  'settings.language': 'ภาษาแอป',
  'settings.preferences': 'การตั้งค่า',
  'settings.sound': 'เอฟเฟกต์เสียง',
  'settings.soundEffects': 'เอฟเฟกต์เสียง',
  'settings.soundEffectsDesc': 'เล่นเสียงเมื่อตอบแบบฝึกหัด',
  'settings.notifications': 'การแจ้งเตือน',
  'settings.notificationsDesc': 'รับการแจ้งเตือนการเรียนรายวัน',
  'settings.darkMode': 'โหมดมืด',
  'settings.darkModeDesc': 'ธีมมืดสำหรับการดูที่สบายตายิ่งขึ้น',
  'settings.dailyReminder': 'การแจ้งเตือนรายวัน',
  'settings.account': 'บัญชี',
  'settings.editProfile': 'แก้ไขโปรไฟล์',
  'settings.privacy': 'ความเป็นส่วนตัว',
  'settings.help': 'ช่วยเหลือ',
  'settings.about': 'เกี่ยวกับ',
  'settings.retakeTest': 'ทำแบบทดสอบระดับอีกครั้ง',
  'settings.retakeTestDesc': 'ตรวจสอบระดับภาษาเกาหลีปัจจุบันของคุณ',
  'settings.terms': 'เงื่อนไขการใช้บริการ',

  // ==================== FOOTER ====================
  'footer.privacy': 'ความเป็นส่วนตัว',
  'footer.terms': 'เงื่อนไข',
  'footer.contact': 'ติดต่อ',
  'footer.rights': 'สงวนลิขสิทธิ์',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'คำศัพท์',
  'quickAction.reviewWords': 'ทบทวนคำศัพท์',
  'quickAction.allCourses': 'คอร์สทั้งหมด',
  'quickAction.browseLessons': 'ดูบทเรียน',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'ไม่พบคอร์ส',
  'courseDetail.lessons': 'บทเรียน',
  'courseDetail.completed': 'เสร็จสิ้น',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'หน้าหลัก',
  'bottomNav.courses': 'คอร์ส',
  'bottomNav.vocab': 'คำศัพท์',
  'bottomNav.profile': 'โปรไฟล์',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'ติวเตอร์ AI',
  'aiTutor.selectScenario': 'เลือกสถานการณ์',
  'aiTutor.freeTalk': 'พูดคุยอิสระ',
  'aiTutor.cafe': 'สั่งของในคาเฟ่',
  'aiTutor.shopping': 'ช้อปปิ้ง',
  'aiTutor.restaurant': 'ร้านอาหาร',
  'aiTutor.friends': 'หาเพื่อน',
  'aiTutor.interview': 'สัมภาษณ์งาน',
  'aiTutor.typeMessage': 'พิมพ์ข้อความ...',
  'aiTutor.send': 'ส่ง',

  // ==================== ERRORS ====================
  'error.generic': 'เกิดข้อผิดพลาด',
  'error.network': 'ข้อผิดพลาดเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ',
  'error.notFound': 'ไม่พบหน้า',
  'error.unauthorized': 'กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ',
  'error.microphoneAccess': 'การเข้าถึงไมโครโฟนถูกปฏิเสธ',
  'error.speechNotSupported': 'การรู้จำเสียงไม่รองรับ ลองใช้ Chrome',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'เราใช้คุกกี้',
  'cookie.description': 'เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์ของคุณ วิเคราะห์ทราฟฟิกของเว็บไซต์ และปรับแต่งเนื้อหา คุณสามารถเลือกยอมรับหรือปฏิเสธคุกกี้ที่ไม่จำเป็น',
  'cookie.learnMore': 'เรียนรู้เพิ่มเติม',
  'cookie.acceptAll': 'ยอมรับทั้งหมด',
  'cookie.rejectAll': 'ปฏิเสธทั้งหมด',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'เรียน',
  'nav.culture': 'วัฒนธรรม',
  'nav.chat': 'แชท',
  'nav.ranking': 'อันดับ',
  'nav.family': 'ครอบครัว',
  'nav.premium': 'พรีเมียม',
  'home.greeting': 'สวัสดี',
  'home.streak': 'วันต่อเนื่อง',
  'home.dailyGoal': 'เป้าหมายรายวัน',
  'home.myLanguages': 'ภาษาของฉัน',
  'home.addLanguage': 'เพิ่มภาษา',
  'home.recommended': 'แนะนำ',
  'home.continue': 'เรียนต่อ',
  'home.selectLanguage': 'เลือกภาษา',
  'home.totalXp': 'XP ทั้งหมด',
  'home.bestStreak': 'สถิติต่อเนื่องสูงสุด',
  'home.level': 'เลเวล',
  'chat.aiTutor': 'ติวเตอร์ AI',
  'chat.aiTutorDesc': 'ฝึกสนทนากับ AI',
  'onboarding.welcome.subtitle': 'เรียนทุกภาษาผ่านบทสนทนาด้วย AI',
  'onboarding.selectUILanguage': 'เลือกภาษาของคุณ',
  'onboarding.selectUILanguage.subtitle': 'ใช้สำหรับหน้าจอแอป',
  'onboarding.selectLearningLanguage': 'อยากเรียนภาษาอะไร?',
  'onboarding.selectLearningLanguage.subtitle': 'เรียนได้หลายภาษา',
  'onboarding.selectDailyGoal': 'ตั้งเป้าหมายรายวัน',
  'onboarding.selectDailyGoal.subtitle': 'วันหนึ่งใช้เวลาได้เท่าไหร่?',
  'onboarding.ready': 'พร้อมแล้ว!',
  'onboarding.ready.subtitle': 'มาเริ่มเส้นทางเรียนภาษากัน',
  'onboarding.features.languages': '4 ภาษา',
  'onboarding.features.aiTutor': 'ติวเตอร์ AI',
  'onboarding.features.dailyGoals': 'เป้าหมายรายวัน',
  'dailyGoal.5min': '5 นาที',
  'dailyGoal.10min': '10 นาที',
  'dailyGoal.15min': '15 นาที',
  'dailyGoal.20min': '20 นาที',
  'dailyGoal.casual': 'เรียนสบายๆ',
  'dailyGoal.regular': 'ฝึกสม่ำเสมอ',
  'dailyGoal.serious': 'ตั้งใจเรียน',
  'dailyGoal.intense': 'ฝึกเข้มข้น',
  'learn.title': 'เรียน',
  'learn.currentLevel': 'เลเวลปัจจุบัน',
  'learn.noCoursesYet': 'เร็วๆ นี้!',
  'learn.noCoursesDescription': 'กำลังเตรียมคอร์สสำหรับภาษานี้',
  'learn.lessonsCompleted': 'บทเรียนที่จบแล้ว',
  'learn.startCourse': 'เริ่มคอร์ส',
  'learn.continueCourse': 'เรียนต่อ',
  'learn.courseCompleted': 'จบแล้ว',
  'learn.locked': 'ล็อกอยู่',
  'learn.unlockBy': 'จบคอร์สก่อนหน้าเพื่อปลดล็อก',
  'course.progress': 'ความคืบหน้า',
  'course.lessons': 'บทเรียน',
  'course.lessonsCompleted': 'บทเรียนที่จบแล้ว',
  'course.noLessons': 'กำลังเตรียมบทเรียน...',
  'lesson.tapToReveal': 'แตะเพื่อดูความหมาย',
  'lesson.examples': 'ตัวอย่าง',
  'lesson.questionsCorrect': 'ถูกต้อง',
  'lesson.wordsLearned': 'คำศัพท์',
  'lesson.grammarPoints': 'ไวยากรณ์',
  'lesson.backToCourse': 'กลับไปที่คอร์ส',
  'lesson.practiceAgain': 'ฝึกอีกครั้ง',
  'lesson.whatYouLearn': 'สิ่งที่จะได้เรียน',
  'lesson.newWords': 'คำศัพท์ใหม่',
  'lesson.exercises': 'แบบฝึกหัด',
  'lesson.startLesson': 'เริ่มบทเรียน',
  'lesson.reviewLesson': 'ทบทวนบทเรียน',
  'lesson.learnVocabulary': 'เรียนคำศัพท์',
  'lesson.grammarPoint': 'จุดไวยากรณ์',
  'lesson.practice': 'ฝึกฝน',
  'profile.guest': 'ผู้เยี่ยมชม',
  'profile.days': 'วัน',
  'profile.longestStreak': 'ยาวนานที่สุด',
  'profile.lessonsCompleted': 'จบแล้ว',
  'profile.dailyGoal': 'เป้าหมายรายวัน',
  'profile.learningLanguages': 'ภาษาที่กำลังเรียน',
  'profile.noLanguages': 'ยังไม่ได้เลือกภาษา',
  'profile.minutesPerDay': 'นาที/วัน',
  'profile.learningHistory': 'ประวัติการเรียน',
  'profile.viewProgress': 'ดูความคืบหน้าของคุณ',
  'profile.appSettings': 'ตั้งค่าแอป',
  'profile.languageNotifications': 'ภาษา, การแจ้งเตือน',
  'profile.loginToSave': 'เข้าสู่ระบบเพื่อบันทึกความคืบหน้า',
  'settings.learning': 'การเรียน',
  'settings.dailyGoal': 'เป้าหมายรายวัน',
  'settings.minutesPerDay': 'นาทีต่อวัน',
  'settings.selectLanguage': 'เลือกภาษา',
  'settings.selectDailyGoal': 'ตั้งเป้าหมายรายวัน',
  'settings.perDay': 'ต่อวัน',
  'settings.appInfo': 'ข้อมูลแอป',
  'settings.logout': 'ออกจากระบบ',
};

export default th;
